module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', [_c('div', {
    staticClass: "bet-name"
  }, [_c('span', [_vm._v(_vm._s(_vm._f("translate")('random')))])]), _vm._v(" "), _c('div', {
    staticClass: "betting-inputs",
    attrs: {
      "id": "bet-area"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.bettingSvc.random),
      expression: "bettingSvc.random"
    }, {
      name: "random-bet-validator",
      rawName: "v-random-bet-validator"
    }],
    attrs: {
      "id": "random",
      "type": "number",
      "autocomplete": "off",
      "disabled": _vm.isBettingDisabled
    },
    domProps: {
      "value": (_vm.bettingSvc.random)
    },
    on: {
      "keydown": [_vm.checkChars, function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        $event.preventDefault();
        _vm.setFocus()
      }, function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "tab", 9)) { return null; }
        $event.preventDefault();
        _vm.setFocus()
      }],
      "click": function($event) {
        _vm.setFocus()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.bettingSvc.random = $event.target.value
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b673fb6a","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/shop/bets/RandomBet.vue
// module id = 408
// module chunks = 0